import { Button } from 'affiny-ui/src';
import React, { lazy, memo, Suspense } from 'react';
import styled from 'styled-components';
import rem from '../../utils/rem';
import { Fallback } from '../fallback';
import { Box, Flex, Text } from '../primitives';

const EmptySOMessage = lazy(() => import('../svgs/svgr/EmptySoMessage'));

type Props = {
  label?: string;
  text?: string;
  soText: string;
  textBtn?: string;
  onClick: (e: React.SyntheticEvent) => void;
};

const EmptySO = ({ label, text, soText, textBtn, onClick }: Props) => {
  return (
    <>
      {label && (
        <Text color="secondary" fontWeight={600} textAlign="center">
          {label}
        </Text>
      )}
      <Flex
        flexDirection="column"
        height="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          boxShadow="box"
          width={rem(736)}
          mx="auto"
          px={rem(180)}
          py={rem(32)}
          maxHeight={rem(342)}
          onClick={onClick}
          cursor="pointer"
        >
          <Box mb="small">
            <Suspense fallback={<Fallback />}>{<EmptySOMessage />}</Suspense>
          </Box>
          {text && (
            <Text
              fontSize={rem(18)}
              lineHeight={rem(24)}
              fontWeight={600}
              textAlign="center"
            >
              {text}
            </Text>
          )}
          <Text
            variant="large"
            fontWeight={600}
            color="caribbeanGreen"
            mt={rem(13)}
          >
            {soText}
          </Text>
          {textBtn && (
            <SButton
              color="subscription"
              onClick={onClick}
              size="small"
              text={textBtn}
              variant="contained"
            />
          )}
        </Flex>
      </Flex>
    </>
  );
};

const SButton = styled(Button)`
  margin-top: ${({ theme }) => theme.space.medium};
`;

export default memo(EmptySO);
